module.exports = __webpack_public_path__ + "static/img/20011 (1).e6359b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20011 (1).jpg
// module id = lImU
// module chunks = 14